// src/components/TodoModal.jsx
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import CustomFieldDesigner from './CustomFieldDesigner';
import { useSelector } from 'react-redux';
import { CUSTOM_SELECT_STYLES, SELECT_BOX_THEME } from '../../constants';
import Select from 'react-select';

export default function TodoModal({ show, onHide, onSubmit }) {
  const [title, setTitle] = useState('');
  const { userList } = useSelector((state) => state.user);
  const [selectedUser, setSelectedUser] = useState({});
  // Fields designed in the modal
  const [customFields, setCustomFields] = useState([]);
  const [formError, setFormError] = useState('');

  const handleSave = async () => {
    // Basic validations before submit
    if (!title.trim()) {
      setFormError('Form title is required');
      return;
    }

    if (!customFields.length) {
      setFormError('Please add at least one field before saving.');
      return;
    }

    setFormError('');

    // Build payload EXACTLY like your backend format
    const payload = {
      title: title?.trim(),
      fields: customFields.map((f) => ({
        label: f.label,
        key: f.key,
        type: f.type,
        options: f.options || [],
        status: f.status || 'pending',
        placeholder: f.placeholder || '',
        value: f.value ?? '',
        required: !!f.required,
      })),
    };

    await onSubmit(payload, selectedUser?._id);
    onHide();
    setTitle("")
    setSelectedUser({})
    setCustomFields([])
    setFormError("")
  };

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static" size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Create Custom Todo / KYC Form</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* User select */}
        <div className="mb-3">
          <label className="form-label">Select User</label>
          <Select
            theme={SELECT_BOX_THEME}
            styles={CUSTOM_SELECT_STYLES}
            className="select-border"
            value={selectedUser}
            onChange={(value) => setSelectedUser(value || {})}
            options={userList}
            isClearable={true}
            getOptionLabel={(option) =>
              option.first_name + ' ' + (option?.last_name || '')
            }
            getOptionValue={(option) => option._id}
            placeholder="Choose user..."
            components={{
              IndicatorSeparator: () => null,
            }}
          />
        </div>

        {/* Title input */}
        <div className="mb-3">
          <label className="form-label">Form Title</label>
          <input
            className="form-control"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="e.g. Custom KYC Form"
          />
        </div>

        {/* Field designer */}
        <CustomFieldDesigner
          customFields={customFields}
          setCustomFields={setCustomFields}
        />

        {/* Form-level error */}
        {formError && (
          <div style={{ marginTop: 12 }}>
            <small style={{ color: 'red' }}>{formError}</small>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="gap-2">
        <button onClick={onHide} className="btn save-btn allow">
          Cancel
        </button>
        <button onClick={handleSave} className="btn save-btn deny">
          Save
        </button>
      </Modal.Footer>
    </Modal>
  );
}
